import React from 'react';

const TradeTransactionCommentFeed = ({ trade, t, currentUserId }) => {
  if (!trade || Object.keys(trade).length === 0) return null;

// Which side does a given userId belong to?
const roleFromUserId = (uid) => {
  if (uid === trade.offerUserId) return 'offerUser';
  if (uid === trade.wantedUserId) return 'wantedUser';
  return 'system'; // fallback if something's off
};

const isCompleted =
  Boolean(trade.completedDate) || trade.Status === 'Completed';

const completedBy = trade.completedByUserId ?? null;

const completedEntry = isCompleted
  ? {
      date: trade.completedDate || trade.acceptedDate, // fallback
      comment: null,
      label: completedBy
        ? `${t('Completed')} • ${
            currentUserId && completedBy === currentUserId
              ? t('by You')
              : t('by Other User')
          }`
        : t('Completed'),
      role: completedBy ? roleFromUserId(completedBy) : 'system',
    }
  : null;


    console.log('completedEntry',completedEntry)
  const commentTimeline = [
    trade?.comments && {
      date: trade.commentsDate,
      comment: trade.comments,
      label: t('Initial Offer'),
      role: 'offerUser',
    },
    trade?.acceptedComments && {
      date: trade.acceptedDate,
      comment: trade.acceptedComments,
      label: t('Accepted'),
      role: 'wantedUser',
    },
    trade?.rejectedComments && {
      date: trade.rejectedDate,
      comment: trade.rejectedComments,
      label: t('Rejected'),
      role: 'wantedUser',
    },
    trade?.Status === 'Countered' && {
      date: trade.counteredDate,
      comment: null,
      label: t('Countered'),
      role: 'wantedUser',
    },
    completedEntry,
    // (Optional) show other closures if you add them later:
    // trade.closedReason === 'canceled' && { date: trade.completedDate, comment: null, label: t('Canceled'), role: roleFromUserId(trade.completedByUserId) },
    // trade.closedReason === 'disputed' && { date: trade.completedDate, comment: trade.disputeNote, label: t('Disputed'), role: roleFromUserId(trade.completedByUserId) },
  ].filter(Boolean);

  if (commentTimeline.length === 0) return null;

  return (
    <div className="transaction-comment-feed">
      {commentTimeline.map((item, i) => (
        <div key={i} className={`comment-entry ${item.role}`}>
          <div className="comment-label">{item.label}</div>
          <div className="comment-date">{new Date(item.date).toLocaleString()}</div>
          {item.comment && <div className="comment-text">{item.comment}</div>}
        </div>
      ))}
    </div>
  );
};

export default TradeTransactionCommentFeed;
